import * as React from "react";
import { Button, IconButton, Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
} from "firebase/storage";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import { createKeywords } from "../generateKeywords";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import MySnackbar from "../MySnackbar";
import { db, storage } from "../../firebase";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import ImageUploader from "./ImageUploader";
import DeleteIcon from "@mui/icons-material/Delete";
import { sProducts } from "../Strings";

export default function AddProduct(props) {
  // const { state } = useLocation();
  const { state } = props;
  const { handleClose } = props;
  const { category } = props;
  const { enqueueSnackbar } = useSnackbar();
  // const [category, setCategory] = useState([]);
  const categoryRef = query(collection(db, "category"), orderBy("name"));
  const [images, setImages] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);
  const [delArray, setDelArray] = useState([]);
  const [selectedCategory, setSelectedCategory] = React.useState([]);
  const history = useHistory();
  const [btnDisabled, setBtnDisabled] = useState(false);

  const [values, setValues] = React.useState({
    name: "",
    price: "",
    desc: "",
    dFee: "",
    status: 0,
    timestamp: "",
    category: [],
    imageURL: [],
  });

  useEffect(() => {
    // get & set data from state
    if (state) {
      setValues(state);
      setImageUrls(state.imageURL);
    }

    /*  getDocs(categoryRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCategory(data);
    }); */
  }, []);

  // const [sCategory, setSCategory] = useState("");
  // const handleChangeSelect = (event) => {
  //   setSCategory(event.target.value);
  //   // add to category array
  //   values.category = [event.target.value];
  //   // console.log(sCategory);
  // };

  const handleChangeSelect = (event) => {
    const {
      target: { value },
    } = event;

    // add selected category id to array
    values.category = event.target.value;

    setSelectedCategory(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const submitUpdate = async () => {
    // if images have been added
    if (images.length > 0) {
      for await (const image of images) {
        const file = image.file;
        const storageRef = ref(storage, `/${sProducts}/${file.lastModified}`);
        await uploadBytes(storageRef, file);
        const imageUrl = await getDownloadURL(storageRef);
        // add directly to imageURL array
        values.imageURL.push(imageUrl);
      }
    }

    // if delete array not empty
    if (delArray.length > 0) {
      for (const imageUrl of delArray) {
        const imageRef = ref(storage, imageUrl);
        deleteObject(imageRef);
      }
    }

    setTypes();
    values.keywords = createKeywords(values.name);

    // send update data
    const docRef = doc(db, sProducts, state.id);
    return setDoc(docRef, values, { merge: true }).then(() => {
      enqueueSnackbar("Product Updated!", { variant: "success" });
      console.log("Document updated");

      // clearForm();
      setBtnDisabled(false);
      handleClose(); // close drawer
    });
    // console.log(docRef);
  };

  function clearForm() {
    setValues({
      name: "",
      price: "",
      timestamp: "",
      desc: "",
      dFee: "",
      status: 0,
      category: [],
      imageURL: [],
    });
    setImageUrls([]);
    setImages([]);
    // state = null;
    // history.push("/product/add");
  }

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: parseInt(event.target.value)
        ? parseInt(event.target.value)
        : event.target.value,
    });
  };

  function setTypes() {
    // prevent string inputs
    if (values.dFee === "") values.dFee = 0;
    if (values.price === "") values.price = 0;
  }

  const setDocData = () => {
    setTypes();
    // console.log(values);
    // Add a new document with a generated id.
    addDoc(collection(db, sProducts), values).then((docRef) => {
      enqueueSnackbar("Product Added!", { variant: "success" });
      console.log("Document written with ID: ", docRef.id);
      clearForm();
      setBtnDisabled(false);
    });
  };

  // async task to upload images
  const getLinks = async () => {
    const array = []; // deposit array
    for await (const image of images) {
      const file = image.file;
      const storageRef = ref(storage, `/${sProducts}/${file.lastModified}`);
      await uploadBytes(storageRef, file);
      const imageUrl = await getDownloadURL(storageRef);
      array.push(imageUrl); // send url to array
    }

    values.imageURL = array;
    values.timestamp = Timestamp.now();
    values.keywords = createKeywords(values.name);
    return setDocData();
  };

  function deleteImage(imageUrl) {
    // values.imageURL = values.imageURL.filter((v) => v !== imageUrl);

    // filter array to remove imageUrl
    var array = imageUrls.filter((v) => v !== imageUrl);
    values.imageURL = array;
    setImageUrls(array);

    setDelArray((prevState) => [...prevState, imageUrl]);
  }

  function buttonClick() {
    if (state) {
      submitUpdate();
    } else {
      getLinks();
    }
    setBtnDisabled(true);
  }

  return (
    <div>
      <h2> {state ? "Update Product" : "Add Product"}</h2>
      <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
        {imageUrls.map((image, key) => (
          <Box key={key}>
            <Box
              component="img"
              sx={{
                height: 150,
                width: 150,
                border: "1px solid #ccc",
                borderRadius: 3,
                objectFit: "contain",
              }}
              src={image}
              alt={values.name}
              loading="lazy"
            />
            <Button
              onClick={() => deleteImage(image)}
              variant="contained"
              sx={{ borderRadius: 50, minWidth: 3, width: 3, ml: -5, mt: -5 }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </Box>
        ))}
      </Stack>

      <div>
        <TextField
          sx={{ mb: 4 }}
          label="Product Name"
          type="text"
          fullWidth
          value={values.name}
          variant="outlined"
          onChange={handleChange("name")}
        />
      </div>

      <div>
        <TextField
          sx={{ mb: 4 }}
          label="Price (SSP)"
          type="number"
          fullWidth
          value={values.price}
          variant="outlined"
          onChange={handleChange("price")}
        />
      </div>

      <div>
        <TextField
          sx={{ mb: 4 }}
          label="Delivery Fee (SSP)"
          type="number"
          fullWidth
          value={values.dFee}
          variant="outlined"
          onChange={handleChange("dFee")}
        />
      </div>

      <Box sx={{ mb: 3 }}>
        <FormControl fullWidth>
          <InputLabel>Category</InputLabel>
          <Select
            // just pass the id value the list will automatically chose option
            value={values.category}
            label="Category"
            multiple
            onChange={handleChangeSelect}
          >
            {category.map((value, key) => (
              <MenuItem key={key} value={value.id}>
                {value.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <div>
        <TextField
          sx={{ mb: 4 }}
          label="Description"
          type="text"
          fullWidth
          variant="outlined"
          value={values.desc}
          multiline
          rows={2}
          onChange={handleChange("desc")}
        />
      </div>

      <ImageUploader images={images} setImages={setImages} />

      <Button
        onClick={buttonClick}
        variant="contained"
        disableElevation
        disabled={btnDisabled}
        fullWidth
        sx={{ height: 40, borderRadius: 1, mb: 3, mt: 2 }}
      >
        {state ? "Update" : "Add Product"}
      </Button>
    </div>
  );
}
